import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { ConversationState } from './conversations.reducer';

// Reminder
// export interface ConversationState {
//   id: ConversationId;
//   collection_id: string | null;
//   replyFromLLM: Message | null;
//   userPrompt: string;
//   isTyping: boolean;
//   messages: Message[];
//   loading: boolean;
//   error: string | null;
// }
export const selectConversation = (state: AppState) => state.history;
export const selectActiveSessionId = createSelector(selectConversation, (state: ConversationState) => state.id);
export const selectActiveCollectionId = createSelector(
  selectConversation,
  (state: ConversationState) => state.collection_id
);
export const selectreplyFromLLM = createSelector(selectConversation, (state: ConversationState) => state.replyFromLLM);
export const selectSourceDocuments = createSelector(
  selectConversation,
  (state: ConversationState) => state.sourceDocuments
);

export const selectUserPrompt = createSelector(selectConversation, (state: ConversationState) => state.userPrompt);
export const selectIsTyping = createSelector(selectConversation, (state: ConversationState) => state.isTyping);
export const selectMessages = createSelector(selectConversation, (state: ConversationState) => state.messages);
export const selectLoading = createSelector(selectConversation, (state: ConversationState) => state.loading);
export const selectError = createSelector(selectConversation, (state: ConversationState) => state.error);
